import React from "react";
// React Table
import { Container, Row, Col, Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaPersonal = ({ datosPersonal, objObrasPersonal }) => {
  return (
    <Container>
      <Row>
        {Object.keys(objObrasPersonal).map((tipoObraPersonal) => {
          return datosPersonal[tipoObraPersonal]?.nPeopleM || datosPersonal[tipoObraPersonal]?.nPeopleF ? (
            <Col key={tipoObraPersonal}>
              <b>{objObrasPersonal[tipoObraPersonal]}</b>
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>Género</th>
                    <th>Nº personal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <CustomTd>
                      <span>Varones</span>
                    </CustomTd>
                    <td>{datosPersonal[tipoObraPersonal]?.nPeopleM !== null ? datosPersonal[tipoObraPersonal]?.nPeopleM : <small>No especificado </small>}</td>
                  </tr>
                  <tr>
                    <CustomTd>
                      <span>Mujeres</span>
                    </CustomTd>
                    <td>{datosPersonal[tipoObraPersonal]?.nPeopleF !== null ? datosPersonal[tipoObraPersonal]?.nPeopleF : <small>No especificado </small>}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          ) : null;
        })}
      </Row>
    </Container>
  );
};

export default VistaPersonal;
